import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '../../../../lib/utils'

export type SaCardVariant = 'default' | 'interactive' | 'metric'

export interface SaCardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode
  variant?: SaCardVariant
  padding?: 'none' | 'sm' | 'md' | 'lg'
}

const PADDING_CLASSES: Record<NonNullable<SaCardProps['padding']>, string> = {
  none: 'p-0',
  sm: 'p-4',
  md: 'p-6',
  lg: 'p-8',
}

export function SaCard ({
  children,
  variant = 'default',
  padding = 'md',
  className,
  ...props
}: SaCardProps) {
  return (
    <div
      className={cn(
        'rounded-sa-lg border border-sa-border bg-sa-surface shadow-sa-sm',
        PADDING_CLASSES[padding],
        variant === 'interactive' && 'transition hover:border-sa-border-strong',
        variant === 'metric' && 'shadow-sa-sm',
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}
